/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import Button from 'src/ui/library/Button';
import classNames from 'classnames';
import intl from 'react-intl-universal';
import Download from '@mui/icons-material/GetApp';

export default function ActionsBarPres({
  percentProgress,
  isNextDisabled,
  isSubmitDisabled,
  isDownloadDisabled,
  isDraftVisible,
  isDraftDisabled,
  isFirstPage,
  isLastPage,
  onNextPage,
  onPrevPage,
  onCancel,
  onSubmit,
  onSaveDraft,
  onDownload,
  onBack,
}) {
  const progressClass = classNames({
    filled: true,
    'filled-complete': percentProgress === 100,
  });

  return (
    <section className="ssi-actions">
      <div className="ssi-button-wrapper">
        <Button styleType="secondary" onClick={onDownload} disabled={isDownloadDisabled} className="action-button download-button">
          <Download />
          {intl.get('consent.downloadSummary')}
        </Button>
        <hr className="vertical-divider" />

        <div className="ssi-wrapper-nextprevious">
          <Button styleType="secondary" disabled={isFirstPage} onClick={onPrevPage} className="action-button prev-button">
            &lt;
          </Button>
          <Button styleType="primary" disabled={isSubmitDisabled} onClick={onSubmit} className="action-button">
            {intl.get('serviceInit.addInit.actionBar.submit')}
          </Button>
          <Button styleType="secondary" disabled={isLastPage || isNextDisabled} onClick={onNextPage} className="action-button next-button">
            &gt;
          </Button>
        </div>
      </div>

      <div className="ssi-progress-wrapper">
        <span className="progress-text">{percentProgress}% complete</span>
        <div className="progress-bar">
          <span className={progressClass} style={{ width: `${percentProgress}%` }} />
        </div>
      </div>
    </section>
  );
}

ActionsBarPres.propTypes = {
  percentProgress: PropTypes.number,
  isNextDisabled: PropTypes.bool,
  isSubmitDisabled: PropTypes.bool.isRequired,
  isDownloadDisabled: PropTypes.bool,
  isDraftDisabled: PropTypes.bool.isRequired,
  isFirstPage: PropTypes.bool.isRequired,
  isLastPage: PropTypes.bool.isRequired,
  onNextPage: PropTypes.func.isRequired,
  onPrevPage: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSaveDraft: PropTypes.func.isRequired,
  onDownload: PropTypes.func,
};
